<template>
  <base-list-item class="scs-contact-event-list-item">
    <contact-name-and-photo :contact="contact" />
    <right-aligned-event-details :event="event" :requests="requests" />
  </base-list-item>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";
import ContactNameAndPhoto from "../ListItemComponents/ContactNameAndPhoto.vue";
import RightAlignedEventDetails from "../ListItemComponents/RightAlignedEventDetails.vue";
export default {
  data() {
    return {};
  },
  computed: {
    contact() {
      return this.event.contacts[0];
    },
  },
  methods: {},
  created() {},
  components: {
    BaseListItem,
    ContactNameAndPhoto,
    RightAlignedEventDetails,
  },
  props: ["event", "requests"],
};
</script>
<style scoped></style>
